import { render, staticRenderFns } from "./MarkingAttributes.vue?vue&type=template&id=6dc10bec&scoped=true&"
import script from "./MarkingAttributes.vue?vue&type=script&lang=js&"
export * from "./MarkingAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc10bec",
  null
  
)

export default component.exports